export default __webpack_public_path__ + "2f8ef3eb51d7233a67b19ac45b7ea321.woff2?proxy=wpt-abc";